import { clone } from 'lodash-es';

export function getGanttColumns($t, schedule) {
  const track_resources = schedule.track_resources;
  const is_published = schedule.is_published;
  const is_manual = schedule.is_manual;
  const published_dates_children = [
    {
      name: 'start',
      label: 'Start',
      type: 'date',
      align: 'center',
      min_width: 90,
      width: 130,
      resize: true,
    },
    {
      name: 'finish',
      label: 'Finish',
      type: 'date',
      align: 'center',
      min_width: 90,
      width: 130,
      resize: true,
    },
    {
      name: 'planned_start',
      label: 'Planned Start',
      type: 'date',
      align: 'center',
      min_width: 80,
      resize: true,
    },
    {
      name: 'planned_finish',
      label: 'Planned Finish',
      type: 'date',
      align: 'center',
      min_width: 85,
      resize: true,
    },
  ];

  const unpublished_dates_children = [
    {
      name: 'start_date',
      label: 'Planned Start',
      type: 'date',
      align: 'center',
      min_width: 90,
      width: 130,
      resize: true,
    },
    {
      name: 'end_date',
      label: 'Planned Finish',
      type: 'date',
      align: 'center',
      min_width: 90,
      width: 130,
      resize: true,
    },
  ];

  return clone([
    {
      name: 'general',
      label: 'General',
      children: [
        {
          name: 'wbs',
          label: 'WBS',
          min_width: 65,
          width: 75,
          resize: true,
        },
        {
          name: 'text',
          label: 'Activity',
          type: 'text',
          min_width: 250,
          width: 300,
          resize: true,
          tree: true,
        },
        {
          name: 'id',
          label: 'ID',
          type: 'text',
          min_width: 55,
          resize: true,
        },
        ...(track_resources
          ? [{
              name: 'resources',
              label: 'Resources',
              type: 'resources',
              min_width: 180,
              resize: true,
            }]
          : []),
        {
          name: 'accountable',
          label: 'Accountable',
          type: 'accountable',
          min_width: 180,
          resize: true,
        },
        {
          name: 'status',
          label: 'Status',
          type: 'text',
          min_width: 75,
          resize: true,
        },
        {
          name: 'predecessors',
          label: 'Predecessors',
          type: 'text',
          min_width: 75,
          resize: true,
        },
        {
          name: 'successors',
          label: 'Successors',
          type: 'text',
          min_width: 75,
          resize: true,
        },
        {
          name: 'is_milestone',
          label: 'Milestone',
          type: 'boolean',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'constraint_type',
          label: 'Constraint type',
          type: 'select',
          align: 'center',
          min_width: 150,
          resize: true,
        },
        {
          name: 'constraint_date',
          label: 'Constraint date',
          type: 'date',
          align: 'center',
          min_width: 150,
          resize: true,
        },
      ],
    },
    {
      name: 'dates',
      label: 'Dates',
      children: [
        {
          name: 'actual_start',
          label: 'Actual Start',
          type: 'date',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'actual_finish',
          label: 'Actual Finish',
          type: 'date',
          align: 'center',
          min_width: 80,
          resize: true,
        },
      ],
    },
    {
      name: 'durations',
      label: 'Durations',
      children: [
        {
          name: 'duration',
          label: 'Duration',
          type: 'number',
          align: 'center',
          min_width: 75,
          width: 80,
          resize: true,
        },
        {
          name: 'planned_duration',
          label: 'Planned Duration',
          type: 'number',
          align: 'center',
          min_width: 90,
          resize: true,
        },
        {
          name: 'actual_duration',
          label: 'Actual Duration',
          type: 'number',
          align: 'center',
          min_width: 95,
          resize: true,
        },
        {
          name: 'remaining_duration',
          label: 'Remaining Duration',
          type: 'number',
          align: 'center',
          min_width: 95,
          resize: true,
        },
        {
          name: 'absolute_remaining_duration',
          label: 'Remaining Schedule Duration',
          type: 'number',
          align: 'center',
          min_width: 95,
          resize: true,
        },
      ],
    },
    {
      name: 'percentages',
      label: 'Percentages',
      children: [
        {
          name: 'progress',
          label: 'Progress',
          type: 'number',
          align: 'center',
          min_width: 80,
          width: 100,
          resize: true,
        },
        {
          name: 'percent_work_complete',
          label: 'Work Complete',
          type: 'number',
          align: 'center',
          min_width: 95,
          resize: true,
        },
        {
          name: 'percent_schedule_complete',
          label: 'Schedule Complete',
          type: 'number',
          align: 'center',
          min_width: 95,
          resize: true,
        },
      ],
    },
    {
      name: 'critical',
      label: 'Critical',
      children: [
        {
          name: 'is_critical',
          label: 'Critical',
          type: 'boolean',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'total_slack',
          label: 'Total Slack',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'free_slack',
          label: 'Free Slack',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
      ],
    },
    {
      name: 'cost_group',
      label: 'Cost',
      children: [
        {
          name: 'cost',
          label: 'Cost',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        ...(is_published
          ? [
              {
                name: 'planned_cost',
                label: 'Planned Cost',
                type: 'number',
                align: 'center',
                min_width: 90,
                resize: true,
              },
            ]
          : [
              {
                name: 'direct_planned_cost',
                label: 'Planned Cost',
                type: 'number',
                align: 'center',
                min_width: 90,
                resize: true,
              },
            ]),
        {
          name: 'actual_cost',
          label: 'Actual Cost',
          type: 'number',
          align: 'center',
          min_width: 95,
          resize: true,
        },
        {
          name: 'remaining_cost',
          label: 'Remaining Cost',
          type: 'number',
          align: 'center',
          min_width: 95,
          resize: true,
        },
      ],
    },
    {
      name: 'work_group',
      label: 'Work',
      children: [
        ...(!is_manual
          ? [
              {
                name: 'work',
                label: 'Work',
                type: 'number',
                align: 'center',
                min_width: 75,
                resize: true,
              },
            ]
          : []
        ),
        {
          name: 'planned_work',
          label: 'Total Work',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'planned_work_upto_now',
          label: 'Planned Work',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'actual_work',
          label: 'Actual Work',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'remaining_work',
          label: 'Remaining Work',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'work_rate',
          label: 'Work Rate',
          type: 'text',
          min_width: 75,
          resize: true,
        },
        {
          name: 'absolute_work_rate',
          label: 'Work Required (Per Day)',
          type: 'text',
          min_width: 75,
          resize: true,
        },
        {
          name: 'planned_work_rate',
          label: 'Work Rate (Planned)',
          type: 'text',
          min_width: 75,
          resize: true,
        },
        {
          name: 'actual_work_rate',
          label: 'Work Rate (Actual)',
          type: 'text',
          min_width: 75,
          resize: true,
        },
        {
          name: 'bl_work_rate',
          label: 'Work Rate (Baseline)',
          type: 'text',
          min_width: 75,
          resize: true,
        },
        {
          name: 'remaining_work_rate',
          label: 'Work Rate (Remaining)',
          type: 'text',
          min_width: 75,
          resize: true,
        },
      ],
    },
    {
      name: 'earned_values',
      label: 'Earned Values',
      children: [
        {
          name: 'planned_value',
          label: 'Planned Value',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'earned_value',
          label: 'Earned Value',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'spi',
          label: 'SPI',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'cpi',
          label: 'CPI',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'schedule_variance',
          label: 'Schedule Variance',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
        {
          name: 'cost_variance',
          label: 'Cost Variance',
          type: 'number',
          align: 'center',
          min_width: 75,
          resize: true,
        },
      ],
    },
  ].map((column) => {
    if (column.name === 'dates' && is_published)
      column.children = [...published_dates_children, ...column.children];
    else if (column.name === 'dates')
      column.children = [...unpublished_dates_children, ...column.children];

    if (column.children) {
      column.children = column.children.map((child) => {
        return {
          ...child,
          label: $t(child.label),
        };
      });
    }
    column.label = $t(column.label);

    return column;
  }));
}
